module.exports = __webpack_public_path__ + "static/media/img169.0b0a4509.jpg";